import { defineStore } from 'pinia'

import { actions } from './actions'
import { createInitialState } from './state'
import { getters } from './getters'

export const useProgressReportStore = defineStore('progress-report', {
  state: createInitialState,
  actions,
  getters,
})
